import { registerLocaleData } from '@angular/common';
import localeEnAU from '@angular/common/locales/en-AU';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

registerLocaleData(localeEnAU);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
